ALLOWED_CONTROLLER = 'access_hubs'
ALLOWED_ACTIONS = ['new', 'edit']

ready = ->
  return unless continueIfAllowed(ALLOWED_CONTROLLER, ALLOWED_ACTIONS)

  $ip_assignment_type = $('#access_hub_ip_assignment_type_id')
  $ip_settings = $(".ip_settings")

  if $ip_assignment_type.val() != '2'
    $ip_settings.hide(duration: 100)

  $ip_assignment_type.on 'change', (e) ->
    if $ip_assignment_type.val() == '2'
      $ip_settings.show()
    else
      $ip_settings.hide()

$(document).ready(ready)
$(document).on('turbo:load', ready)
